import React, { useEffect, useState } from "react";
import axios from "axios";

function App() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const AGENTS_API_URL = "/api/agents";
  const CALL_API_URL = "/api/initiateCall";

  // データ取得関数
  const fetchAgents = async () => {
    try {
      const response = await axios.get(AGENTS_API_URL);
      setAgents(response.data || []);
      setError(null);
    } catch (err) {
      console.error("エージェント取得エラー:", err);
      setError("エージェントの取得に失敗しました");
    } finally {
      setLoading(false);
    }
  };

  // 初回取得 + 5秒ごとの polling
  useEffect(() => {
    fetchAgents(); // 初回取得

    const intervalId = setInterval(() => {
      fetchAgents(); // 5秒ごとに取得
    }, 5000);

    // クリーンアップ
    return () => clearInterval(intervalId);
  }, []);

  // 通話発信
  const initiateCall = async (agentId) => {
    try {
      await axios.post(CALL_API_URL, { agentId });
      alert(`内線通話リクエスト送信: ${agentId}`);
    } catch (err) {
      console.error("通話リクエスト失敗:", err);
      alert("通話リクエストに失敗しました");
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h2>エージェント一覧</h2>

      {loading && <p>読み込み中...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && agents.length === 0 && (
        <p>エージェントデータがありません</p>
      )}

      {!loading && !error && agents.length > 0 && (
        <table border="1" cellPadding="8" cellSpacing="0">
          <thead>
            <tr>
              <th>ログイン</th>
              <th>ステータス</th>
              <th>アクション</th>
            </tr>
          </thead>
          <tbody>
            {agents.map((a) => (
              <tr key={a.Login}>
                <td>{a.Login}</td>
                <td>{a.AgentStatus}</td>
                <td>
                  <button onClick={() => initiateCall(a.Login)}>
                    通話 📞
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default App;
